module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/20mill-inactive-b8c223b858aa0edca13b76de1e9e3653.png";